import { render, staticRenderFns } from "./BasePopUp.vue?vue&type=template&id=16a96490&scoped=true"
import script from "./BasePopUp.vue?vue&type=script&lang=js"
export * from "./BasePopUp.vue?vue&type=script&lang=js"
import style0 from "./BasePopUp.vue?vue&type=style&index=0&id=16a96490&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a96490",
  null
  
)

export default component.exports